import { connect } from 'react-redux'
import Admin, { IAdminDispatchProps } from './Admin'
import { IGlobalState } from '../../Root/store/appReducer'
import { userCompaniesSelector, managedCompaniesSelector } from '../Settings/store/SettingsSelectors'
import { getCompanyAdminSelectedCompanyId } from '../CompanyAdmin/store/CompanyAdminSelectors'
import { isSuperAdmin } from '../../common/auth/authSelectors'
import { getSuperAdminTargetCompany } from '../SuperAdmin/store/SuperAdminSelectors'
import { clearSuperAdminTargetCompany } from '../SuperAdmin/store/SuperAdminActions'

const mapStateToProps = (state: IGlobalState, ownProps: any) => {
  // SSO sub-routes (/admin/sso/add, /admin/sso/:configId/edit) don't have :tab param,
  // so fall back to extracting the tab name from the pathname.
  let tab = ownProps.match?.params?.tab || null
  if (!tab) {
    const pathname = ownProps.location?.pathname || ''
    const parts = pathname.split('/')
    if (parts.length >= 3 && parts[1] === 'admin') {
      tab = parts[2]
    }
  }
  const targetCompany = getSuperAdminTargetCompany(state)
  return {
    tab,
    userCompanies: userCompaniesSelector(state),
    managedCompanies: managedCompaniesSelector(state),
    adminSelectedCompanyId: getCompanyAdminSelectedCompanyId(state),
    isSuperAdmin: isSuperAdmin(state),
    superAdminTargetCompanyName: targetCompany?.companyName || null,
  }
}

const mapDispatchToProps: IAdminDispatchProps = {
  clearSuperAdminTargetCompany,
}

export default connect(mapStateToProps, mapDispatchToProps)(Admin)
